import { forEach, map } from 'lodash-es'

import { showErrorNotification } from '../../../../common/helpers'

import { brandDefinitionTaskSchema } from '../schemas'

const validateState = async state => {
  try {
    await brandDefinitionTaskSchema.validate(state, { abortEarly: false })
    return true
  } catch ({ inner }) {
    const errors = map(inner, 'message')

    forEach(errors, error =>
      showErrorNotification({
        message: error,
      }),
    )

    return false
  }
}

export default validateState
